import { FILTER_TYPE } from 'components/FiltersBlock/types';

// TODO
// Переделать - за ГП нам не нужно пробрасывать id, берется на бэке.
// Для остальных ролей пробрасывать нужно
export const STRUCTURE_FILTER = {
  label: 'Объект',
  name: 'structure',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/structures/?page=1',
};
